import { SidebarProvider } from "@design-system/components";
import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import {
  CONNECT_SIDEBAR_STORAGE_KEY,
  FEATURE_FLAGS,
} from "@spiriidk/connect-configs";
import { getFlag } from "@spiriidk/feature-flags";
import React, { Activity, useCallback, useState } from "react";

import {
  DomainDeprecationDialog,
  FullPageLoader,
  SpiriiUIFlagWatcher,
} from "./components";
import { DebugInfoDialog } from "./features/debug-info";
import {
  ImpersonateDialog,
  ImpersonatedViewFrame,
} from "./features/impersonation";
import { AppSidebar } from "./features/navigation";
import { useMicrofrontendLoading } from "./hooks";

function App() {
  const isSpiriiUIEnabled = getFlag(FEATURE_FLAGS.SPIRII_UI);
  const [isImpersonateDialogOpen, setIsImpersonateDialogOpen] = useState(false);
  const [isDebugInfoDialogOpen, setIsDebugInfoDialogOpen] = useState(false);
  const isMicrofrontendLoading = useMicrofrontendLoading();

  const handleOpenImpersonateDialog = useCallback(() => {
    setIsImpersonateDialogOpen(true);
  }, []);

  const handleOpenDebugInfoDialog = useCallback(() => {
    setIsDebugInfoDialogOpen(true);
  }, []);

  return (
    <I18nProvider i18n={i18n}>
      <DomainDeprecationDialog />
      <SpiriiUIFlagWatcher />
      <SidebarProvider storageKey={CONNECT_SIDEBAR_STORAGE_KEY}>
        {isSpiriiUIEnabled && (
          <AppSidebar
            onOpenImpersonateDialog={handleOpenImpersonateDialog}
            onOpenDebugInfoDialog={handleOpenDebugInfoDialog}
          />
        )}
        <div className="min-w-0 flex-1">
          <div className="grid min-h-screen w-full flex-1 grid-cols-1 grid-rows-1">
            <Activity mode={isMicrofrontendLoading ? "visible" : "hidden"}>
              <FullPageLoader className="col-start-1 row-start-1" />
            </Activity>
            <div
              id="single-spa-application:@spiriidk/connect"
              className="col-start-1 row-start-1 flex min-h-screen w-full flex-col empty:hidden"
            />
            <div
              id="single-spa-application:@spiriidk/tech-ui"
              className="col-start-1 row-start-1 flex min-h-screen w-full flex-col empty:hidden"
            />
          </div>
        </div>
      </SidebarProvider>
      {isSpiriiUIEnabled && (
        <ImpersonatedViewFrame onEditClick={handleOpenImpersonateDialog} />
      )}
      <ImpersonateDialog
        open={isImpersonateDialogOpen}
        onOpenChange={setIsImpersonateDialogOpen}
      />
      <DebugInfoDialog
        open={isDebugInfoDialogOpen}
        onOpenChange={setIsDebugInfoDialogOpen}
      />
    </I18nProvider>
  );
}

export { App };
